import { i18next } from '@yola/ws-sdk';

const createRequiredValidator = (errorMessage) => (value) =>
  value && value.trim() ? null : errorMessage;

const validateRequired = createRequiredValidator(i18next.t('This field is required'));

export default createRequiredValidator;
export { validateRequired };
